<template>
  <v-card
    elevation="0"
    outlined
  >
    <v-card-title>
      <v-icon class="mr-2">
        mdi-chart-line
      </v-icon>
      Overall Summary
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col
          cols="6"
          md="3"
        >
          <v-card outlined>
            <v-card-text class="text-center">
              <div class="text-h4 primary--text">
                {{ summaryData.matchedLeadCount.toLocaleString() }}
              </div>
              <div class="text-caption">
                Matched Leads
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="6"
          md="3"
        >
          <v-card outlined>
            <v-card-text class="text-center">
              <div class="text-h4 success--text">
                {{ summaryData.acceptedLeadCount.toLocaleString() }}
              </div>
              <div class="text-caption">
                Accepted Leads
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="6"
          md="3"
        >
          <v-card outlined>
            <v-card-text class="text-center">
              <div class="text-h4 info--text">
                {{ summaryData.fundedLeadCount.toLocaleString() }}
              </div>
              <div class="text-caption">
                Funded Leads
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="6"
          md="3"
        >
          <v-card outlined>
            <v-card-text class="text-center">
              <div class="text-h4 warning--text">
                ${{ summaryData.totalFundedAmount.toLocaleString() }}
              </div>
              <div class="text-caption">
                Total Funded Amount
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="mt-2">
        <v-col
          cols="6"
          md="6"
        >
          <v-card outlined>
            <v-card-text class="text-center">
              <div class="text-h5">
                {{ summaryData.acceptanceRate }}%
              </div>
              <div class="text-caption">
                Acceptance Rate
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="6"
          md="6"
        >
          <v-card outlined>
            <v-card-text class="text-center">
              <div class="text-h5">
                {{ summaryData.fundingRate }}%
              </div>
              <div class="text-caption">
                Funding Rate
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatPercentage } from '@/filters.js';

export default {
  name: 'ReportSummary',

  props: {
    summaryData: {
      type: Object,
      default: () => ({
        matchedLeadCount: 0,
        acceptedLeadCount: 0,
        fundedLeadCount: 0,
        totalFundedAmount: 0,
        matchedLeadPercentage: 0,
        acceptedLeadPercentage: 0,
        fundedLeadPercentage: 0,
        acceptanceRate: 0,
        fundingRate: 0,
      }),
    },
  },

  methods: {
    formatPercentage,
  },
};
</script>
